module.exports = __webpack_public_path__ + "files/0106d095203c22f3a97e90a9e9719c30.png";